import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import TextField from '../TextField';

const SelectField = ({ disabledKey = 'disabled', labelKey = 'label', options, valueKey = 'value', ...props }) => (
  <TextField
    {...props}
    select
    SelectProps={{
      displayEmpty: true,
      MenuProps: {
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'bottom',
        },
      },
    }}
  >
    {options.map((item) => (
      <MenuItem
        disabled={item?.[disabledKey] || false}
        key={item[valueKey]}
        sx={{ whiteSpace: 'break-spaces' }}
        value={item[valueKey]}
      >
        {item[labelKey]}
      </MenuItem>
    ))}
  </TextField>
);

SelectField.propTypes = {
  disabledKey: PropTypes.string,
  labelKey: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  valueKey: PropTypes.string,
};

export default SelectField;
